import { render, staticRenderFns } from "./ProductDescriptionSelect.vue?vue&type=template&id=2b8a82b1&"
import script from "./ProductDescriptionSelect.vue?vue&type=script&lang=js&"
export * from "./ProductDescriptionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8a82b1')) {
      api.createRecord('2b8a82b1', component.options)
    } else {
      api.reload('2b8a82b1', component.options)
    }
    module.hot.accept("./ProductDescriptionSelect.vue?vue&type=template&id=2b8a82b1&", function () {
      api.rerender('2b8a82b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selects/ProductDescriptionSelect.vue"
export default component.exports